import XeroSerializer from './base';

export default class Ledger extends XeroSerializer {
  primaryKey = 'code';

  normalize(model, hash, prop) {
    let defaults = {
      existsInHero: false,
      isChanged: false,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
